import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { useMutation, useQuery } from 'react-query';
import {
  getCompaniesEligible,
  selectCompanyLogin,
} from 'services/CompanyService';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { toast } from 'react-toastify';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import {
  clearActivationToken,
  isActivationSessionEnded,
} from 'services/ActivationTokenService';

// onSessionEnded: the link's session ended (a 401); the page sends the contact
// back to sign in on the link.
export const useGetCompaniesEligible = (
  userId: string,
  token: string,
  searchBy: string,
  onSessionEnded: () => void
) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_COMPANIES_ELIGIBLE, userId, token, searchBy],
    queryFn: () => getCompaniesEligible(userId, token, searchBy),
    retry: (failureCount, error) =>
      !isActivationSessionEnded(error) && failureCount < 3,
    onError: (error: LogyxError) => {
      if (isActivationSessionEnded(error)) {
        toast.error(getToastErrorMessage(error));
        onSessionEnded();
      }
    },
    onSuccess: (data) => {
      return data;
    },
  });

export const useSelectCompanyLogin = (
  token: string,
  userId: string,
  onSessionEnded: () => void
) =>
  useMutation(
    (dto: { companyId: number }) =>
      selectCompanyLogin(token, userId, dto.companyId),
    {
      onSuccess: () => {
        clearActivationToken();
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
        if (isActivationSessionEnded(error)) {
          onSessionEnded();
        }
      },
      mutationKey: ReactMutationKeys.SELECT_COMPANY_LOGIN,
    }
  );
